<script>
/**
 * @file 产后课程
 */

// 假数据
import dateClassList from '../__mock__/classes';

import Confirm from './confirm';
import ForkissIcon from './forkiss-icon';
import mixin from './mixins_api';

const CATEGORY_POSTPARTUM = 2;

export default {
    mixins: [mixin],
    components: {
        Confirm,
        ForkissIcon
    },
    computed: {
       statusClass() { // 对应按钮样式类
            // 1:已约 2:取消或者未约(2的时候可以约课) 3：候补中
            return function (order_status) {
                switch (order_status) {
                    case '1':
                        return 'status-cancel'; // '取消预约';
                    case '2':
                        return 'status-apply';
                    case '3':
                        return 'status-cancel'; // '取消候补';
                    default:
                        return '';
                }
            }
        },
    },
    methods: {
        goto() {
            this.$router.push({name: 'pregnancy'});
        },
        toggleDate(dateClass, index) {
            this.activeIndex = index;
            this.currentDate = dateClass.date;
            this.fetchList(dateClass.date);
        },
        handleClickOrderBtn(classes) {
            this.currentOperateId = classes.id;
            let {status, msg} = this.getOrderStatus(classes);
            if (status === 2) {
                this.isShowCancelBook = true;
                return;
            }
            this.createOrder({
                course_id: classes.id,
                status: status
            }).then(res => {
                this.$root.$emit('showToast', msg);
                if (msg === '预约成功') {
                    wx.miniProgram.navigateTo({url: '/pages/msg/msg?url=https://m.forkiss.com.cn/w.html'});
                }
                this.fetchList(this.currentDate);
            });
        },
        handleOk() {
            this.createOrder({
                course_id: this.currentOperateId,
                status: 2
            }).then(res => {
                this.$root.$emit('showToast', '取消成功');
                this.fetchList(this.currentDate);
            });
            this.isShowCancelBook = false;
        },
        handleCancel() {
            this.isShowCancelBook = false;
        },
        viewDetail(id) {
            this.$router.push({
                name: 'classes-detail',
                params: {
                    id,
                    refer_name: 'postpartum'
                }
            });
        },
        handleTouchPlay() {
            let self = this;
            let moveX;
            let startX;
            let movebox = this.$refs.postpartumContainer;

            // 触摸开始
            function boxTouchStart(e) {
                let touch = e.touches[0];
                startX = touch.pageX;
            }

            function boxTouchMove(e) {
                let touch = e.touches[0];
                moveX = touch.pageX - startX;
            }

            function boxTouchEnd(e) {
                if (moveX > 0) { // 向右
                    self.$router.push({
                        name: 'pregnancy'
                    });
                }

                if (moveX < 0) { // 向左
                    console.log('handleTouchPlay 向左')
                }
            }

            // 滑动对象事件绑定
            movebox.addEventListener('touchstart', boxTouchStart, false);
            movebox.addEventListener('touchmove', boxTouchMove, false);
            movebox.addEventListener('touchend', boxTouchEnd, false);
        },
        fetchList(date) {
            this.getCourseList(date, CATEGORY_POSTPARTUM).then(res => {
                this.classesList = res.result;
            });
        }

    },
    created() {
        this.getCourseLatest(CATEGORY_POSTPARTUM).then(response => {
            this.dateList = response.result || [];
            let date = this.dateList[0] && this.dateList[0].date;
            this.currentDate = date;
            this.fetchList(date);
        });
    },
    mounted() {
        // 和日期选择的左右滑动冲突了，去掉页面滑动切换功能
        // this.$nextTick(function () {
        //     this.handleTouchPlay();
        // });
    },
    data() {
        return {
            activeIndex: 0,
            currentDate: '',
            currentOperateId: {},
            dateList: [],
            classesList: [],
            isShowCancelBook: false
        };
    }
};

</script>

<template lang="pug">
.forkiss-postpartum-container(ref="postpartumContainer")
    .tabs-box
        .tab-item(@click="goto")
            span 孕期课程
        .tab-item.active
            span 产后课程
    .date-container
        .date-wrapper(v-for="(dateClass, index) in dateList",
            :class="{active: activeIndex === index}",
            @click="toggleDate(dateClass, index)")
            .date-box
                .date {{dateClass.date}}
                .week {{dateClass.week | week}}
            .line-box
    .classes-content-wrapper
        .classes-box(v-for="(classes, index) in classesList", :key="index")
            .classes-card(@click="viewDetail(classes.id)", data-touch="true",
                :style="`background-image: url(${classes.pic})`")
                .classes-mask
                    img.classes-img(:src="classes.teacher_pic")
                    .classes-text-box
                        .name {{classes.title}}
                        ForkissIcon.time(icon="forkiss-icon-time") {{classes.start_time | date("YYYY-mm-dd HH:MM")}}
                        ForkissIcon.address(icon="forkiss-icon-address") {{classes.room_name}}
                    .classes-info
                        span.booked-count {{classes.apply_num}}
                        span /
                        span {{classes.capacity}}
                        span 人
            .classes-btn(:class="statusClass(classes.order_status)",
                data-touch="true",
                @click="handleClickOrderBtn(classes)") {{statusBtnText(classes)}}
    Confirm(:show="isShowCancelBook", message="确定取消预约？", @ok="handleOk",
        @close="handleCancel")
</template>

<style lang="less" scoped>
.forkiss-postpartum-container {
    position: relative;
    padding-bottom: 1rem;
    font-size: .24rem;

    .tabs-box {
        display: flex;
        height: .88rem;
        line-height: .88rem;
        padding: 0 1rem;
        box-shadow: 0 .05rem .08rem 0 rgba(227, 227, 227, .27);
        font-size: .28rem;

        .tab-item {
            position: relative;
            flex: 1;
            color: #828d93;
            text-align: center;

            span {
                position: relative;
            }

            &.active {
                color: #a4805b;

                span::after {
                    content: "";
                    position: absolute;
                    top: 100%;
                    left: 0;
                    right: 0;
                    height: .02rem;
                    background: #a5805a;
                }
            }
        }
    }

    .date-container {
        position: relative;
        white-space: nowrap;
        overflow-x: auto;
        padding: .3rem 0 .2rem;

        &::before {
            content: "";
            position: absolute;
            width: .56rem;
            bottom: .2rem;
            height: 1px;
            background: #edf0f7;
        }
    }
    .date-wrapper {
        display: inline-block;
        width: 2.2rem;
        text-align: center;
        color: #a8abb0;

        &:first-child {
            margin-left: .56rem;
        }

        .date-box {
            position: relative;
            padding: .15rem 0;

            &::before {
                content: "";
                position: absolute;
                z-index: 22;
                top: 100%;
                left: 50%;
                transform: translateX(-50%);
                margin-top: .2rem;
                width: .12rem;
                height: .12rem;
                background-image: url(../assets/small-circle.svg);
                background-repeat: no-repeat;
                background-size: contain;
                border-radius: 50%;
            }
        }

        .line-box {
            position: relative;
            height: 1px;
            background: #edf0f7;
            margin-top: .25rem;
        }
        &.active {

            .date-box {
                background: #dfc9b0;
                color: #fff;
                border-radius: 1rem;

                &::after {
                    content: "";
                    position: absolute;
                    top: 100%;
                    left: 50%;
                    width: 0;
                    height: 0;
                    border-top: .15rem solid #dfc9b0;
                    border-left: .1rem solid transparent;
                    border-right: .1rem solid transparent;
                    margin-top: -1px;
                    transform: translateX(-50%);
                }

                &::before {
                    content: "";
                    position: absolute;
                    z-index: 22;
                    top: 100%;
                    left: 50%;
                    transform: translateX(-50%);
                    margin-top: .18rem;
                    width: .15rem;
                    height: .15rem;
                    background-image: url(../assets/middle-circle.svg);
                    background-repeat: no-repeat;
                    background-size: contain;
                    border-radius: 50%;
                }
            }
        }
    }

    .classes-content-wrapper {
        padding: .5rem .3rem;
    }

    .classes-box {
        margin-bottom: .5rem;
        box-shadow: 0 .05rem .08rem 0 rgba(227, 227, 227, .27);
        text-align: center;
    }

    .classes-card {
        position: relative;
        height: 2.52rem;
        background:  url(../assets/classes-bg1.png);
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        text-align: left;

        * {
            pointer-events: none;
        }
    }
    .classes-mask {
        position: relative;
        width: 100%;
        height: 100%;
        padding-left: .28rem;
    }

    .classes-img {
        display: inline-block;
        vertical-align: top;
        width: 1.6rem;
        height: 1.6rem;
        background-image: url(../assets/classes-avatar.png);
        background-size: contain;
        border-radius: 50%;
        margin-right: .22rem;
        margin-top: .32rem;

    }
    .classes-text-box {
        display: inline-block;
        vertical-align: top;
        margin-top: .54rem;
        color: #a4805b;

        .name {
            font-size: .28rem;
            margin-bottom: .15rem;
            color: #e2c19d;
        }
        .time {
            color: rgba(227, 227, 227, .7);

        }
        .address {
            color: rgba(227, 227, 227, .7);
        }
    }
    .classes-info {
        position: absolute;
        top: 1.36rem;
        right: .54rem;
        color: #e2c19d;

        .booked-count {
            font-size: .34rem;
        }
    }

    .classes-btn {
        display: inline-block;
        width: 2.4rem;
        height: .68rem;
        line-height: .68rem;
        text-align: center;
        margin: .2rem auto;
        color: #fff;
        border-radius: .4rem;

        &.status-cancel {
            background: #f5d8b7;
        }

        &.status-apply {
            background: #c3a07b;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/postpartum.vue